import React from 'react';
import Icon from '../../../components/AppIcon';

const OrderProgressIndicator = ({ currentStatus, statusHistory }) => {
  const statusSteps = [
    { id: 'received', label: '주문 접수', icon: 'ClipboardCheck' },
    { id: 'pickup_scheduled', label: '픽업 예정', icon: 'Calendar' },
    { id: 'in_progress', label: '세탁 진행중', icon: 'Loader' },
    { id: 'delivery_scheduled', label: '배송 예정', icon: 'Truck' },
    { id: 'completed', label: '완료', icon: 'CheckCircle2' }
  ];

  const getCurrentStepIndex = () => {
    return statusSteps?.findIndex(step => step?.id === currentStatus);
  };

  const currentStepIndex = getCurrentStepIndex();

  const getStatusTimestamp = (statusId) => {
    const history = statusHistory?.find(h => h?.status === statusId);
    return history?.timestamp;
  };

  const formatTimestamp = (timestamp) => {
    if (!timestamp) return null;
    const date = new Date(timestamp);
    return `${date?.getMonth() + 1}월 ${date?.getDate()}일 ${date?.getHours()}:${String(date?.getMinutes())?.padStart(2, '0')}`;
  };

  return (
    <div className="w-full rounded-lg bg-card p-6 shadow-lg transition-all duration-300 hover:shadow-xl sm:p-8">
      <h3 className="mb-6 text-xl font-bold text-foreground">진행 상태</h3>
      {/* Desktop Progress Bar */}
      <div className="hidden md:block">
        <div className="relative">
          <div className="absolute left-0 top-6 h-0.5 w-full bg-border"></div>
          <div
            className="absolute left-0 top-6 h-0.5 bg-primary transition-all duration-500"
            style={{ width: `${(currentStepIndex / (statusSteps?.length - 1)) * 100}%` }}
          ></div>

          <div className="relative flex justify-between">
            {statusSteps?.map((step, index) => {
              const isCompleted = index <= currentStepIndex;
              const isCurrent = index === currentStepIndex;
              const timestamp = getStatusTimestamp(step?.id);

              return (
                <div key={step?.id} className="flex flex-col items-center" style={{ width: '20%' }}>
                  <div
                    className={`flex h-12 w-12 items-center justify-center rounded-full border-2 transition-all duration-300 ${
                      isCompleted
                        ? 'border-primary bg-primary text-primary-foreground'
                        : 'border-border bg-card text-muted-foreground'
                    } ${isCurrent ? 'ring-4 ring-primary/20' : ''}`}
                  >
                    <Icon name={step?.icon} size={24} />
                  </div>
                  <p
                    className={`mt-3 text-center text-sm font-medium ${
                      isCompleted ? 'text-foreground' : 'text-muted-foreground'
                    }`}
                  >
                    {step?.label}
                  </p>
                  {timestamp && (
                    <p className="mt-1 text-xs text-muted-foreground">
                      {formatTimestamp(timestamp)}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {/* Mobile Progress List */}
      <div className="md:hidden">
        <div className="space-y-4">
          {statusSteps?.map((step, index) => {
            const isCompleted = index <= currentStepIndex;
            const isCurrent = index === currentStepIndex;
            const timestamp = getStatusTimestamp(step?.id);

            return (
              <div key={step?.id} className="flex items-start space-x-4">
                <div className="relative flex flex-col items-center">
                  <div
                    className={`flex h-10 w-10 items-center justify-center rounded-full border-2 transition-all duration-300 ${
                      isCompleted
                        ? 'border-primary bg-primary text-primary-foreground'
                        : 'border-border bg-card text-muted-foreground'
                    } ${isCurrent ? 'ring-4 ring-primary/20' : ''}`}
                  >
                    <Icon name={step?.icon} size={20} />
                  </div>
                  {index < statusSteps?.length - 1 && (
                    <div
                      className={`mt-2 h-8 w-0.5 ${
                        isCompleted ? 'bg-primary' : 'bg-border'
                      }`}
                    ></div>
                  )}
                </div>
                <div className="flex-1 pb-2">
                  <p
                    className={`font-medium ${
                      isCompleted ? 'text-foreground' : 'text-muted-foreground'
                    }`}
                  >
                    {step?.label}
                  </p>
                  {timestamp && (
                    <p className="mt-1 text-xs text-muted-foreground">
                      {formatTimestamp(timestamp)}
                    </p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default OrderProgressIndicator;